/**
 * @desc 获取结算报告请求分页
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.platDataFlow.AmzonReportSettlementPageDto, options?: any) {
  return updateResponse(
    http(URL + `/getSettlementReportIdList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
